// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d7Zm","label":"styles_label__2aa2r"};